"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_config_1 = require("../@internal/app-config");
const LoginRedirect = (url = '') => {
    const loginUrl = url ? url : (0, app_config_1.getAppConfig)().authStrategy.loginUrl;
    window.location.replace(loginUrl);
    return null;
};
exports.default = LoginRedirect;
